module.exports = {"dropDownPlaceholder":"不使用 Adobe ID 登入"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/zh_tw.json
// module id = 935
// module chunks = 0